var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_2248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 256C0 366.07 69.472 459.905 166.955 496.076L189.217 255.999L166.955 15.923C69.472 52.095 0 145.929 0 256Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 114.616 397.384 0 256 0C224.686 0 194.689 5.633 166.955 15.923V496.077C194.689 506.368 224.686 512 256 512C397.384 512 512 397.384 512 256Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.957 345.043C216.134 345.043 256 305.177 256 256C256 206.823 216.134 166.957 166.957 166.957C117.78 166.957 77.9141 206.823 77.9141 256C77.9141 305.177 117.78 345.043 166.957 345.043Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87 211.478V267.13C116.87 294.792 139.294 317.217 166.957 317.217C194.62 317.217 217.044 294.793 217.044 267.13V211.478H116.87Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.957 283.826C157.751 283.826 150.261 276.336 150.261 267.13V244.87H183.652V267.131C183.652 276.336 176.162 283.826 166.957 283.826Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_2248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/portugal.9d78aab2c5de7f6a9cc0cfce547448f7.svg";
export { ForwardRef as ReactComponent };